import React, { ChangeEvent, useContext } from 'react';
import { Box, TextField } from '@mui/material';
import { InputContext } from '../chat-input';

const InputText = ({ isNewTicket }: { isNewTicket: boolean }) => {
    const inputHook = useContext(InputContext);
    const {
        inputRef,
        currentMessage,
        placeHolderText,
        setCurrentMessage,
        lengthError,
        isSending,
    } = inputHook!;

    return (
        <Box sx={{ flex: 1, minWidth: 0 }}>
            <TextField
                inputRef={inputRef}
                label={isNewTicket ? 'متن تیکت' : undefined}
                placeholder={placeHolderText || 'پیام خود را وارد کنید...'}
                variant="outlined"
                value={currentMessage}
                disabled={!isNewTicket && isSending}
                error={!!lengthError}
                helperText={isNewTicket && lengthError ? lengthError : undefined}
                onChange={(e: ChangeEvent<HTMLInputElement>) => setCurrentMessage(e.target.value)}
                multiline
                fullWidth
                minRows={isNewTicket ? 4 : 1}
                maxRows={isNewTicket ? 6 : 4}
                inputProps={{ maxLength: isNewTicket ? 500 : undefined }}
                sx={isNewTicket ? undefined : {
                    '& .MuiInputBase-root.MuiOutlinedInput-root': {
                        padding: '7px !important',
                        alignItems: 'flex-end',
                    },
                    '& fieldset': { border: '0 !important' },
                    '& textarea': {
                        padding: '0 !important',
                        lineHeight: 1.8,
                        fontSize: 14,
                    },
                }}
            />

        </Box>
    );
};

export default InputText;
